import React from 'react';
import {Loading} from '../../grid-dx/loading/loading';
import FormikAutocomplete from './FormikAutocomplete';

///ESTE ES PARA LOS QUE TIENEN DOBLE PALABRA
const AutocompleteMultiname = ({
  disabled,
  type,
  label,
  field,
  lookup,
  fullWidth,
  myLabel,
  lookupColumn,
  formikProps,
}: MultiNameInAutocomplete) => {
  const lookupData = lookup.find((x) => x.column === field);
  if (typeof lookupData === 'undefined') {
    return <Loading />;
  }

  let useMyLabel = '';
  if (myLabel !== '#') {
    useMyLabel = myLabel;
  } else {
    useMyLabel = label;
  }
  return (
    <FormikAutocomplete
      options={lookupData.values}
      name={field}
      displayValue={lookupData.displayValue}
      keyValue={lookupData.keyValue}
      label={useMyLabel}
      formikProps={formikProps}
      fullWidth={fullWidth}
      disabled={disabled}
      lookupColumn={lookupColumn}
      multiName={true}
    />
  );
};

interface MultiNameInAutocomplete {
  disabled: boolean;
  type: string;
  label: string;
  field: string;
  lookup: any[];
  fullWidth: boolean;
  myLabel: string;
  lookupColumn: string;
  formikProps: any;
}

export default AutocompleteMultiname;
